import type { ImageSet } from "@b2bportal/core-themes";
import bannerCashback from "../assets/images/banner-cashback.jpg";
import bannerEnhanceBurn from "../assets/images/banner-enhance-burn.jpg";
import bannerPremierDestination from "../assets/images/banner-premier-destination.jpg";
import carLoadingImage from "../assets/images/car-loading.jpg";
import flightLoadingMobileImage from "../assets/images/flight-loading-mobile.jpg";
import flightLoadingImage from "../assets/images/flight-loading.jpg";
import hotelLoadingImage from "../assets/images/hotel-loading.jpg";
import hsbcLogoWhite from "../assets/images/hsbc-logo-white.svg";
import logo from "../assets/images/logo.svg";
import mobileBackground from "../assets/images/mobile-background.png";
import partnershipLogoBlack from "../assets/images/partnership-logo-black.png";
import partnershipLogoWhite from "../assets/images/partnership-logo-white.png";
import homepageBackground from "../assets/images/portal-background.jpeg";
import premierDestinationAustralia from "../assets/images/prem-dest-australia.jpg";
import premierDestinationBannerPopup from "../assets/images/prem-dest-banner-popup.jpg";
import premierDestinationChina from "../assets/images/prem-dest-china.jpg";
import premierDestinationFrance from "../assets/images/prem-dest-france.jpg";
import premierDestinationItaly from "../assets/images/prem-dest-italy.jpg";
import premierDestinationJapan from "../assets/images/prem-dest-japan.jpg";
import premierDestinationKorea from "../assets/images/prem-dest-korea.jpg";
import premierDestinationThailand from "../assets/images/prem-dest-thailand.jpg";
import premierDestinationUsa from "../assets/images/prem-dest-usa.jpg";
import premierMastercard from "../assets/images/premier-mastercard.png";

export const images: ImageSet = {
  flightLoadingImage,
  flightLoadingMobileImage,
  hotelLoadingImage,
  carLoadingImage,
  logo,
  homepageBackground,
  mobileBackground,
  tripsLoadingImage: "https://fakeimg.pl/600x400",
  tripsHeadingBackground: "https://fakeimg.pl/800x200/?text=Wide%20Image",
  bannerPremierDestination,
  bannerEnhanceBurn,
  bannerCashback,
  hsbcLogoWhite,
  partnershipLogoWhite,
  partnershipLogoBlack,
  premierMastercard,
  premierDestinationJapan,
  premierDestinationChina,
  premierDestinationAustralia,
  premierDestinationItaly,
  premierDestinationFrance,
  premierDestinationUsa,
  premierDestinationKorea,
  premierDestinationThailand,
  premierDestinationBannerPopup,
};

export default images;
